import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import React from 'react';
import classnames from 'classnames';

const styles = require('./WSPNewDesignButton.less');
const cx = classnames.bind(styles);

interface IWSPNewDesignButtonProps
{
    className?:string;
}

export class WSPNewDesignButton extends React.Component<IWSPNewDesignButtonProps, any>
{
    private async _onClickNewDesign()
    {
        controllers.data.projects.syncAllProjects();

        controllers.ui.dialogs.showDialog(Dialogs.AddDesign, false);
    }
    
    render()
    {
        return <div
            id="newDesignBtn"
            className={cx(styles.newDesign, this.props.className)}
            onClick={this._onClickNewDesign}
        >
            <MDIcon
                className={styles.btnIcon}
                name={MDIcons.common.Add}
            />
            New design
        </div>
    }
}